import i18n from 'i18next';
import type { AppLocale } from './languages';
import { normalizeAppLocale } from './languages';

type LocaleModule = { default: Record<string, unknown> };

const loaders: Record<Exclude<AppLocale, 'en'>, () => Promise<LocaleModule>> = {
  es: () => import('./locales/es.json'),
  fr: () => import('./locales/fr.json'),
  de: () => import('./locales/de.json'),
  pt: () => import('./locales/pt.json'),
  zh: () => import('./locales/zh.json'),
  ja: () => import('./locales/ja.json'),
  hi: () => import('./locales/hi.json'),
  ar: () => import('./locales/ar.json'),
};

const loaded = new Set<AppLocale>(['en']);

/** Lazy-load a locale bundle once (code-split per language — no perf hit at startup). */
export async function ensureLocaleLoaded(locale: string): Promise<AppLocale> {
  const code = normalizeAppLocale(locale);
  if (code === 'en' || loaded.has(code)) return code;

  const loader = loaders[code];
  if (!loader) return 'en';

  const mod = await loader();
  i18n.addResourceBundle(code, 'translation', mod.default, true, true);
  loaded.add(code);
  return code;
}

export function isLocaleLoaded(locale: string): boolean {
  const code = normalizeAppLocale(locale);
  return code === 'en' || loaded.has(code);
}
